import styled from 'styled-components';
import { FullHeightContainer } from '.';
import { breakpoints } from '../../constants';

export const AutoHeightContainer = styled(FullHeightContainer)`
    height: auto;

    @media (${breakpoints.mediumMin}) {
        height: 100vh;
    }
`;
